import { render, staticRenderFns } from "./PurchasedValuePass.vue?vue&type=template&id=42d974f0&"
import script from "./PurchasedValuePass.vue?vue&type=script&lang=js&"
export * from "./PurchasedValuePass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports